import Api from "../services/Api";
import PythonApi from "../services/PythonApi";

export default {
  async list(payload) {
    const url = "cows", params = new URLSearchParams();
    if (payload) {
      if (payload.with_building)
        params.append('with_building', true);
      if (payload.with_bolus)
        params.append('with_bolus', true);
      if (payload.with_heat_index)
        params.append('with_heat_index', true)
      if (payload.include_archived)
        params.append('include_archived', true);
      if (payload.include_deleted)
        params.append('include_deleted', true);
      if (payload.include_culled)
        params.append('include_culled', true);
    }
    return PythonApi().get(url, params);
  },

  async get(id, payload) {
    const url = `cows/${id}`, params = new URLSearchParams();
    if (payload) {
      if (payload.with_alerts)
        params.append('with_alerts', true);

      if (payload.with_events)
        params.append('with_events', true);

      if (payload.with_status)
        params.append('with_status', true);

      if (payload.with_heat_index)
        params.append('with_heat_index', true);
    }
    return PythonApi().get(url, params);
  },

  async lactation() {
    const url = "cows/lactation_report";

    return PythonApi().get(url, new URLSearchParams());
  },

  async editCow(id, data) {
    const url = `cows/${id}`
    return PythonApi().put(url, data);
  },

  async createCow(data) {
    let url = `cows`;
    return PythonApi().post(url, data);
  },

  async getNeighbours(id, state, key, dir) {
    let url = `v2/cows/neighbours/${id}?`;
    if (typeof state !== 'undefined')
      url += `state=${state}&`;
    if (typeof key !== 'undefined' && typeof dir !== 'undefined') {
      url += `key=${key}&dir=${dir.toString()}`
    }
    return Api().get(url);
  }
};



// WEBPACK FOOTER //
// ./src/api/cows-api.js